import type {
  EnrichedSpiffApproval,
  EnrichedSpiffApprovalUser,
} from "@/spiff-approvals/spiff-approval";

/**
 * Type guard to check if an approval is an EnrichedSpiffApprovalUser
 * (single-user approval with user_id and spiff_approval_id fields)
 */
export const isEnrichedSpiffApprovalUser = (
  approval: EnrichedSpiffApproval | EnrichedSpiffApprovalUser,
): approval is EnrichedSpiffApprovalUser =>
  "user_id" in approval && "spiff_approval_id" in approval;
